<template>
  <div class="page-control">
    <ul class="pagination pull-right">
      <li :class="{ disabled: pageNumStart == 1 }" @click="previousPage(maxPageNum)">
        <a>&lt;&lt;</a>
      </li>
      <li :class="{ disabled: pageNumStart == 1 }" @click="previousPage(1)">
        <a>&lt;</a>
      </li>
      <li :class="{ active: pageNumArrItem == item }" v-for="(item, index) in pageNumArr" :key="index"
        @click="clickPage(item, index)">
        <a>{{ item }}</a>
      </li>
      <li :class="{ disabled: pageNumEnd == allPageNum }" @click="nextPage(1)">
        <a>&gt;</a>
      </li>
      <li :class="{ disabled: pageNumEnd == allPageNum }" @click="nextPage(maxPageNum)">
        <a>&gt;&gt;</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    pageData: {
      type: Array,
      default: () => []
    },
    // 总条数
    total: {
      type: Number,
      default: 1,
    },
    // 一页多少条数据
    pageSize: {
      type: Number,
      default: 10
    },
    // 最长展示多少页面,移动端超过4会分行
    maxPageNum: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      allPageNum: 1, // 总页面数
      groupPageData: {}, // 按页，分好的数据
      pageNumStart: 1, // 展示的开始页
      pageNumEnd: 1, // 展示的结束页
      pageNumArrItem: 1 // 选中第几个页面
    };
  },
  created() { },
  mounted() { },
  methods: {
    clickPage(item, index) {
      this.pageNumArrItem = item;
      // this.$emit("pageChange", this.groupPageData[item]);
      this.$emit('pageChange',item)
    },
    previousPage(num) {
      let { pageNumStart, maxPageNum } = this;
      if (pageNumStart == 1) return;
      let subNum = pageNumStart - num;
      this.pageNumStart = subNum <= 1 ? 1 : subNum;
      this.pageNumEnd = this.pageNumStart + maxPageNum - 1;
    },
    nextPage(num) {
      let { pageNumEnd, allPageNum, maxPageNum } = this;
      if (pageNumEnd == allPageNum) return;
      let addNum = pageNumEnd + num;
      this.pageNumEnd = addNum >= allPageNum ? allPageNum : addNum;
      this.pageNumStart = this.pageNumEnd - maxPageNum + 1;
    }
  },
  computed: {
    // 展示的页面数
    pageNumArr() {
      let num = this.pageNumEnd - this.pageNumStart + 1;
      let arr = [];
      for (let i = 0; i < num; i++) {
        arr.push(this.pageNumStart + i);
      }
      return arr;
    }
  },
  watch: {
    total: {
      handler(newValue) {
        this.allPageNum = Math.ceil(this.total / this.pageSize);
        if (this.total == 0) this.allPageNum = 1;
        // for (let i = 0; i < this.allPageNum; i++) {
        //   let key = i + 1;
        //   this.groupPageData[key] = this.pageData.slice(
        //     this.pageSize * i,
        //     this.pageSize * key
        //   );
        // }
        // this.$emit("pageChange", this.groupPageData[1]);
        this.pageNumEnd = this.allPageNum >= this.maxPageNum ? this.maxPageNum : this.allPageNum;
        this.$emit('pageChange',this.pageNumArrItem)
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/page-control.vue